import React from 'react'
import { Link } from 'react-router-dom'
import "./notfound.scss"
import { useTheme } from '../../contexts/ThemeProvider';
import { DARK_THEME } from '../../utils/constants';

const NotFound = () => {
    const { theme } = useTheme();
    return (
        <>
            <section className="error-section">
                {
                    theme === DARK_THEME ? <img src="\assets\homepage\banner\banner-shadow.png" alt="img" className='img-fluid banner-shadow' /> : <>
                        <img src="\assets\homepage\banner\banner-shadowlight.png" alt="img" className='img-fluid banner-shadow' />
                    </>
                }
                <video
                    className="main-banner-video"
                    muted="muted"
                    playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="https://res.cloudinary.com/drt6vurtt/video/upload/v1736418767/rain-prediction/banner-video_jshcjv.mp4" type="video/mp4" />
                </video>
                <div className="custom-container">
                    <div className="parent">
                        <h2>4 <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
                            <circle cx="31" cy="31" r="31" fill="#212121" />
                            <path d="M31.0573 9.70932C32.111 25.8274 50.2598 23.7328 50.2598 30.9234C50.2598 36.7857 41.6388 39.9275 30.9999 39.9275C20.3609 39.9275 11.7399 36.7857 11.7399 30.9234C11.7335 23.7328 29.8823 25.8274 30.9424 9.70932C18.6495 9.74125 8.7002 19.2563 8.7002 31C8.7002 42.7437 18.6814 52.2907 30.9999 52.2907C43.3183 52.2907 53.2995 42.7565 53.2995 31C53.2995 19.2435 43.3438 9.74125 31.0573 9.70932Z" fill="#E6FF00" />
                        </svg> 4</h2>
                        <h6>Looks like it’s not raining on this page</h6>
                        <p>The page you’re looking for doesn’t exist or may have moved. Let’s get you back to a safe place.</p>
                        <Link to="/">Back to Homepage</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NotFound
